import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

export const SaveSchedule = async (schedule, toasterMessage) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/WorkRequirement/save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(schedule),
        });

        const data = await response.json();    
       // console.log(data)    

        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success(toasterMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};

export const GetSchedule = async (schedule) => {

  if(!schedule?.entityID)
    {
      
      return [];
    }
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/WorkRequirement/get?workReqID=${schedule?.workReqID}&entityID=${schedule?.entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
        // console.log(data)

      if (response.ok && !data.isError) {
        return data // Assuming `result` is the array of linked entities
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return [];
  }
};

export const changeStatus = async (requestID, newStatus) => {
  const accesstoken = getToken();
  
  const statusObj = {
    requestID : Number(requestID),
    status : newStatus
  }

  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/updateStatus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(statusObj),
      });
  

      const data = await response.json();
        
        // console.log(data)

      if (response.ok && !data.isError) {
        if (response.ok && !data.isError) {
          // Show success message from the API response
          // toast.success("Status Updated!", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: true,
          //   closeOnClick: false,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light"
          //   });
            return data;           
        }  
        return data // Assuming `result` is the array of linked entities
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return [];
  }
};
